var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconideas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 88,
    fill: "none",
    viewBox: "0 0 90 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.811,
    height: 86.927,
    x: 0.071,
    y: 0.104,
    fill: "#fff",
    fillOpacity: 0.15,
    rx: 16.737
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 89.421,
    height: 86.538,
    x: 0.266,
    y: 0.299,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 0.389,
    rx: 16.543
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M44.586 22.59a1.61 1.61 0 0 0 0 3.22c5.329 0 9.664 4.335 9.664 9.663a1.61 1.61 0 0 0 3.22 0c0-7.104-5.78-12.883-12.884-12.883Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M40.437 16.582c-7.276 1.52-13.175 7.363-14.728 14.684-1.31 6.182.305 12.388 4.432 17.027 2.017 2.268 3.174 5.262 3.174 8.222v3.22a4.839 4.839 0 0 0 3.338 4.594c.636 3.76 3.9 6.786 7.935 6.786 4.033 0 7.297-3.025 7.934-6.786a4.839 4.839 0 0 0 3.338-4.594v-3.22c0-2.966 1.16-5.924 3.268-8.328a19.28 19.28 0 0 0 4.784-12.715c0-12.192-11.16-21.463-23.475-18.89Zm4.15 51.312c-2.07 0-3.885-1.424-4.555-3.338h9.11c-.67 1.914-2.484 3.338-4.554 3.338Zm8.052-8.159c0 .888-.722 1.61-1.61 1.61H38.146c-.888 0-1.61-.722-1.61-1.61v-1.61h16.103v1.61Zm4.067-13.67c-2.246 2.561-3.627 5.651-3.978 8.84h-16.28a15.914 15.914 0 0 0-3.9-8.752c-3.44-3.867-4.784-9.05-3.688-14.22 1.28-6.034 6.197-10.937 12.236-12.198C51.404 17.58 60.69 25.322 60.69 35.471c0 3.899-1.415 7.66-3.985 10.592ZM21.935 35.473h-3.22a1.61 1.61 0 1 0 0 3.22h3.22a1.61 1.61 0 1 0 0-3.22Zm.667-8.053-2.277-2.276a1.61 1.61 0 1 0-2.278 2.277l2.278 2.277a1.61 1.61 0 1 0 2.277-2.277Zm0 17.048a1.61 1.61 0 0 0-2.277 0l-2.278 2.277a1.61 1.61 0 0 0 2.278 2.278l2.277-2.278a1.61 1.61 0 0 0 0-2.277Zm47.858-8.995h-3.22a1.61 1.61 0 0 0 0 3.22h3.22a1.61 1.61 0 0 0 0-3.22Zm.668-10.329a1.61 1.61 0 0 0-2.278 0l-2.277 2.277a1.61 1.61 0 0 0 2.277 2.277l2.278-2.277a1.61 1.61 0 0 0 0-2.277Zm0 21.601-2.278-2.277a1.61 1.61 0 1 0-2.277 2.277l2.277 2.278a1.61 1.61 0 0 0 2.278-2.278Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h54.967v54.967H0z",
    transform: "translate(17.104 16.15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconideas);
export default __webpack_public_path__ + "static/media/icon ideas.5c323ca1d876a7eb1afd311d659a762d.svg";
export { ForwardRef as ReactComponent };